import { ApiBase } from '../api.js';
import { BrandData, BrandDetailsData, BrandsParameters } from '../types/api/brands.js';

export class ApiBrand extends ApiBase {
	async create(data: FormData): Promise<BrandData> {
		const result = await this.api.post('/brands', data, {
			headers: { 'Content-Type': 'multipart/form-data', Accept: '*/*' }
		});

		return result.data;
	}
	async createProvider(data: any): Promise<unknown> {
		const result = await this.api.post('/brands/create-provider', data, {});
		return result.data;
	}

	async read(data: BrandsParameters): Promise<BrandDetailsData> {
		const result = await this.api.get('/brands', {
			params: {
				...data
			}
		});
		return result.data;
	}

	async updateShutdownCheckerTier(data: { id: string, shutdown_checker_override_tier: number | null; }): Promise<unknown> {
		const result = await this.api.put(`/brands/${ data.id }/shutdown-checker-tier-override`, data);
		return result.data;
	}

	async readList(data: any): Promise<unknown> {
		const result = await this.api.get('/brands/list', {
			params: {
				...data
			}
		});
		return result.data;
	}

	async getAll(data: any): Promise<unknown> {
		const result = await this.api.get('/brands/all-active', {
			params: {
				...data
			}
		});
		return result.data;
	}

	async readData(params): Promise<BrandDetailsData> {
		const result = await this.api.get('/brands/list', {
			params: {
				...params
			}
		});
		return result.data;
	}
	async clone(data: FormData): Promise<BrandData> {
		const result = await this.api.post('/brands/clone', data, {
			headers: { 'Content-Type': 'multipart/form-data', Accept: '*/*' }
		});
		return result.data;
	}
	async readTopList(data: any): Promise<unknown> {
		const result = await this.api.get('/brands/top-list', {
			params: {
				...data
			}
		});
		return result.data;
	}
	async update(data: any): Promise<unknown> {
		const result = await this.api.put(`/brands/${ data.id }`, data.data, {
			headers: { 'Content-Type': 'multipart/form-data', Accept: '*/*' }
		});
		return result.data;
	}

	async updateStatus(data: any): Promise<unknown> {
		const result = await this.api.put(`/brands/status-update/${ data.id }`, data.data, {
			headers: { Accept: '*/*' }
		});
		return result.data;
	}

	async getById(data: unknown): Promise<unknown> {
		const result = await this.api.get(`/brands/${ data }`);
		return result.data;
	}

	async delete(data: any): Promise<unknown> {
		const result = await this.api.delete(`/brands/${ data }`);
		return result.data;
	}
	async deleteDoc(id: any): Promise<unknown> {
		const result = await this.api.delete(`/brands/doc/${ id }`);
		return result.data;
	}

	async marketplace(data: any): Promise<unknown> {
		const result = await this.api.get(`/brands/marketplace/${ data.id }`, {
			params: {
				...data
			}
		});
		return result.data;
	}
	async provider(data: any): Promise<unknown> {
		const result = await this.api.get(`/brands/brand-provider/${ data }`);
		return result.data;
	}

	async marketplaceEnabled(data: any): Promise<unknown> {
		const result = await this.api.post('/brands/marketplace-enable', data, {});
		return result.data;
	}
	async getBrandsProvider(data: any): Promise<unknown> {
		const result = await this.api.get(`/brands/provider-brands/${ data.id }`, {
			params: {
				...data
			}
		});
		return result.data;
	}

	async getBrandsByLicensor(licensorId: string): Promise<unknown> {
		const result = await this.api.get(`/brands/licensor/${ licensorId }`);
		return result.data;
	}

	async findBrandsDefaultIPs(brandIds: string[]): Promise<unknown> {
		const result = await this.api.get(`/brands/default-ips`, {
			params: {
				brand_ids: brandIds
			}
		});
		return result.data;
	}
}
